import React, { Component } from "react";
import { NavBar } from "../../components/Navbar";
import HeroSmart from "../../components/HeroSmart";
import Footer from "../../components/Footer";
import styled from "styled-components";

export default class Cookies extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: props.user,
      mobileNavHidden: true,
    };
    this.toggleMobileNav = this.toggleMobileNav.bind(this);
  }

  componentDidMount() {
    // scroll to 0 0 because it's a react app and will remember how far down the screen it is otherwise.
    window.scrollTo(0, 0);
    this.setState({ mobileNavHidden: true });
  }

  toggleMobileNav() {
    this.setState({ mobileNavHidden: !this.state.mobileNavHidden });
  }

  render() {
    return (
      <div className="error_root">
        <HeroSmart
          login={false}
          backgroundName={"https://tubac-woodworks.s3-us-west-1.amazonaws.com/error.jpg"}
          title="Privacy Policy"
          subTitle=""
        />
        <NavBar isHidden={this.state.mobileNavHidden} toggle={this.toggleMobileNav} />
        <StyledSection>
          <h4>
            Privacy Policy Last updated: <time>10/21/2026</time>
          </h4>
          <h2>Tubac Woodworks LLC</h2>

          <p className="p1">
            <span className="s1">
              Tubac Woodworks, LLC ("us", "we", or "our") operates{" "}
              <a href="https://www.tubacwoodworks.com/" target="_blank" rel="noopener noreferrer">
                <span className="s2">https://www.tubacwoodworks.com</span>
              </a>
              . This Privacy Policy informs you of our policies regarding the collection, use, and disclosure of Personal Information we receive from users of the Site and our applications.
            </span>
          </p>
          <p className="p1">
            <span className="s1">
              We use your Personal Information only for providing and improving the Site and our services. By using the Site, you agree to the collection and use of information in accordance with this policy.
            </span>
          </p>

          <h2>User Data Policy & Usage</h2>
      <p>
        <strong>Tubac Woodworks</strong> uses Google OAuth services for user authentication 
        and account authorization. This section details how we handle user data when 
        you submit your information on our website form.
      </p>

      <h3>1. Information We Collect from Google</h3>
      <p>
        When you sign up for a free consultation, we collect:
      </p>
      <ul>
        <li><strong>Basic Account Information:</strong> Your first name, last name, email address, and phone number.</li>
        <li><strong>[Optional Scopes]:</strong> [e.g., Google Calendar events — delete or modify based on requested OAuth scopes].</li>
      </ul>

      <h3>2. How We Use Your Data</h3>
      <p>
        We access and use your data strictly to provide and improve customer experience. Specifically:
      </p>
      <ul>
        <li>We will use your data to provide you with the services you requested, such as email notification, call to schedule a free consultation and any future email marketing.</li>
        <li>To authenticate your identity and allow you to log in securely.</li>
        <li>To communicate regarding orders, account updates, or support inquiries.</li>
        <li>[Add specific features, e.g., "To sync project appointment details to your account"].</li>
      </ul>

      <h3>3. How We Store and Protect Your Data</h3>
      <p>
        User data is stored on secure, encrypted servers. We implement standard administrative, 
        technical, and physical security measures to protect your personal information against unauthorized access, 
        alteration, disclosure, or destruction.
      </p>

      <h3>4. Sharing and Disclosure</h3>
      <p>
        We do <strong>not</strong> sell, rent, or trade your Google user data to third parties. We do not share 
        your Google account data with any third-party tools, advertising partners, or generalized AI models. 
        Data is only disclosed if required by law or as necessary to provide core application features.
      </p>

      <h3>5. Google API Limited Use Disclosure</h3>
      <p>
        Tubac Woodworks' use and transfer to any other app of information received from Google APIs will 
        adhere to the{' '}
        <a 
          href="https://developers.google.com/terms/api-services-user-data-policy" 
          target="_blank" 
          rel="noopener noreferrer"
        >
          Google API Services User Data Policy
        </a>, including the <em>Limited Use</em> requirements.
      </p>

      <h3>6. Data Retention and Deletion</h3>
      <p>
        We retain user data only for as long as your account remains active with us or as necessary to fulfill 
        the purposes outlined in this policy. You can request the deletion of your account and associated data 
        at any time by emailing us at{' '}
        <a href="mailto:tubacww@gmail.com">tubacww@gmail.com</a>.
      </p>
      <p>
        You can also revoke Tubac Woodworks’ access to your Google data at any time via your{' '}
        <a 
          href="https://myaccount.google.com/permissions" 
          target="_blank" 
          rel="noopener noreferrer"
        >
          Google Security Settings
        </a>.
      </p>

          <h2>
            <span className="s1"><b>7. Changes to This Privacy Policy</b></span>
          </h2>
          <p className="p1">
            <span className="s1">
              This Privacy Policy is effective as of October 21, 2026, and will remain in effect except with respect to any changes in its provisions in the future, which will be in effect immediately after being posted on this page.
            </span>
          </p>
          <p className="p1">
            <span className="s1">
              We reserve the right to update or change our Privacy Policy at any time. If we make any material changes, we will notify you either through the email address you have provided us or by placing a prominent notice on our website.
            </span>
          </p>

          <h2>
            <span className="s1"><b>Contact Us</b></span>
          </h2>
          <p className="p1">
            <span className="s1">For additional information about our company policies or privacy practices, please feel free to contact us:</span>
          </p>
          <ul className="ul1">
            <li className="li1"><span className="s1"><b>Email:</b> <a href="mailto:tubacww@gmail.com">tubacww@gmail.com</a></span></li>
            <li className="li1"><span className="s1"><b>Phone:</b> (520) 625-0050</span></li>
            <li className="li1"><span className="s1"><b>Address:</b> 25700 S Via Montana Vista, Green Valley, AZ 85622</span></li>
          </ul>
        </StyledSection>
        <Footer />
      </div>
    );
  }
}

// ========== //
//   STYLES   //
// ========== //
const StyledSection = styled.section`
  max-width: 1400px;
  padding: 1em;
  margin: 0 auto;

  h2,
  h3 {
    font-weight: 800;
  }

  h4 {
    font-size: 1em;
    font-weight: 200;
  }

  p {
    max-width: 80%;
  }

  span.s1 {
    font-kerning: none;
  }

  span.s2 {
    text-decoration: underline;
    font-kerning: none;
    color: #0000e9;
    -webkit-text-stroke: 0px #0000e9;
  }

  span.s3 {
    -webkit-text-stroke: 0px #000000;
  }

  ol.ol1 {
    list-style-type: decimal;
  }

  ul.ul1 {
    list-style-type: disc;
  }

  ul.ul2 {
    list-style-type: circle;
  }

  a,
  a:hover,
  a:active,
  a:visited {
    color: #c0392b;
    font-weight: 800;
  }
`;
